module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-album-9171eece.svg";